import React from 'react';
import { Filter } from 'react-admin';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  button: {
    border: '1px solid',
    borderColor: '#E0E0E0',
    borderRadius: '2px',
    backgroundColor: 'white',
    marginTop: '8px',
    height: '28px',
    '& svg': { display: 'none' },
    '& button': { paddingTop: '2px', fontSize: '14px' }
  }
});

const StyledFilter = props => {
  const classes = useStyles();
  return <Filter classes={classes} {...props} />;
};

export default StyledFilter;
